import BackstageLogoIcon from './BackstageLogoIcon';

const LogoIcon = BackstageLogoIcon;

export default LogoIcon;
